<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="newTableViewModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="newTableViewModalLabel">
            {{ $t("topBar.saveCurrentView") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`confirmModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label bold-12 text-gray">
              {{ $t("topBar.viewName") }}
            </label>
            <input
              type="text"
              class="form-control"
              v-model="newViewName"
              :placeholder="$t('topBar.viewName')"
            />
          </div>
          <div class="mb-3">
            <label class="form-label bold-12 text-gray d-block">
              {{ $t("topBar.visibility") }}
            </label>
            <div class="d-flex">
              <label class="cstm-check me-3">
                <span class="regular-12 text-black">{{
                  $t("topBar.private")
                }}</span>
                <input type="radio" :value="0" v-model="viewVisibility" />
                <span class="checkmark radio"></span>
              </label>
              <label class="cstm-check me-3">
                <span class="regular-12 text-black">{{
                  $t("topBar.public")
                }}</span>
                <input type="radio" :value="1" v-model="viewVisibility" />
                <span class="checkmark radio"></span>
              </label>
              <label class="cstm-check">
                <span class="regular-12 text-black">{{
                  $t("topBar.role")
                }}</span>
                <input type="radio" :value="2" v-model="viewVisibility" />
                <span class="checkmark radio"></span>
              </label>
            </div>
          </div>
          <div class="mb-3" v-if="viewVisibility === 2">
            <label class="form-label bold-12 text-gray">
              {{ $t("topBar.selectRole") }}
            </label>
            <select class="form-select" v-model="selectedRole">
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="!newViewName"
            v-on:click="save"
          >
            {{ $t("finance.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";
import { useStore } from "vuex";

const bootstrap = require("bootstrap");

export default {
  name: "NewTableViewModal",
  props: {
    path: String,
  },
  data() {
    return {
      store: useStore(),
      myModal: undefined,
      newViewName: "",
      viewVisibility: 0,
      roles: [],
      selectedRole: null,
    };
  },
  emits: ["saved"],
  watch: {
    viewVisibility() {
      if (this.viewVisibility === 2) {
        http
          .fetch("/users/roles")
          .then((data) => {
            this.roles = data;
            if (this.roles.length > 0) {
              this.selectedRole = this.roles[0].id;
            }
          })
          .catch(() => {
            this.roles = [];
          });
      }
    },
  },
  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.newViewName = "";
      this.viewVisibility = 0;
      this.myModal.show();
    },
    save() {
      if (!this.newViewName) return;
      if (this.viewVisibility === 2 && !this.selectedRole) return;
      const filterPage = this.store.state.filterPage;
      const currentFilters = filterPage
        ? this.store.state.filters[filterPage] || {}
        : this.store.state.filters[this.path] || {};
      const data = {
        path: this.path,
        name: this.newViewName,
        filters: currentFilters,
        visibility: this.viewVisibility,
        role_id: this.viewVisibility === 2 ? this.selectedRole : null,
      };
      http.fetch("/table-views/add", data, true).then((res) => {
        this.$emit("saved", res);
        this.myModal.hide();
      });
    },
  },
};
</script>
